<template>
	<el-card shadow="never" class="l-main-card">
		<el-tabs v-model="activeName" style="margin-top: -10px">
			<el-tab-pane label="资产借用" name="1"></el-tab-pane>
			<el-tab-pane label="资产归还" name="2"></el-tab-pane>
		</el-tabs>

		<div v-if="activeName == 1">
			<l-assets-borrow-index />
		</div>
		<div v-if="activeName == 2">
			<l-assets-back-index />
		</div>
	</el-card>
</template>

<script>
import Borrow from "../assets_borrow/Index";
import Back from "../assets_back/Index";
export default {
	components: {
		[Borrow.name]: Borrow,
		[Back.name]: Back,
	},
	name: "l-assets-borrow-back-index",
	data() {
		return {
			activeName: "1",
		};
	},

	methods: {},
};
</script>
